<script lang="ts">
	import { createBubbler } from 'svelte/legacy';

	const bubble = createBubbler();
	interface Props {
		searchTerm: string;
		placeholder?: string;
		overrideClasses?: string;
	}

	let { searchTerm = $bindable(), placeholder = 'Search', overrideClasses = '' }: Props = $props();
</script>

<div id="search-input-cont">
	<input
		type="search"
		class="input-caret-color input h-9 !w-32 !rounded-full !text-sm font-semibold text-surface-800-200 {overrideClasses}"
		{placeholder}
		autocomplete="off"
		bind:value={searchTerm}
		oninput={bubble('input')}
	/>
</div>
